<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('ecranAjoutFaces.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="annuler()"
               class="button">
              {{ $t('ecranAjoutFaces.actions.back')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level pdt-10px mgb-0">
      <div class="level-left has-text-default">
        <span v-if="criteresRecherche.fromDate && criteresRecherche.toDate">
          {{ $t('ecranAjoutFaces.periode',
          { dateDebut: formatDate(criteresRecherche.fromDate),
            dateFin: formatDate(criteresRecherche.toDate)})}}
        </span>
        <span v-else-if="criteresRecherche.fromDate">
          {{ $t('ecranAjoutFaces.dateFrom',
          { dateDebut: formatDate(criteresRecherche.fromDate)})}}
        </span>
      </div>
      <div class="level-right column is-narrow">
        <div class="column is-pulled-right is-paddingless">
          <button class="button" @click='showSelection = !showSelection'>
            <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7"> {{$t('ecranAjoutFaces.buttons.selection')}} </span>
          </button>
          <div class="info-circle-right background-danger is-pulled-right"
               v-if="selection.length > 0">
            <span class="inside-circle">{{ selection.length > 9 ? '9+' : selection.length }}</span>
          </div>
        </div>
        <div class="column is-pulled-right is-paddingless">
          <button class="button" @click='showRecherche = !showRecherche'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">{{$t('ecranAjoutFaces.buttons.search')}}</span>
          </button>
          <div class="info-circle-right background-primary is-pulled-right"
               :class="{'is-invisible': nombreFiltre === 0}">
            <span class="inside-circle">{{ nombreFiltre }}</span>
          </div>
        </div>
      </div>
    </div>
    <v-server-table url=""
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    @error="finLoading"
                    ref="tableListeProduits">
      <template slot='afterTable'>
        <table-items-in-view :perPage="RESULTS_PER_PAGE_PLANNING"
                             @input="$refs.tableListeProduits.setLimit($event)"/>
      </template>
      <div slot="addPanier" slot-scope="props" class="has-text-centered">
        <button
          @click="ajouterALaSelection(props.row)"
          class="ripple button" :class="getColorAddPanier(props.row.id)">
          <b-icon icon="plus-circle"></b-icon>
        </button>
      </div>
      <div slot="affectation" slot-scope="props">
        <a class="lien" @click="affichageAffectations(props.row)"
           v-if="props.row.affectations && props.row.affectations.length > 0">
          {{props.row.affectations[0].libelle}}
          <span v-if="props.row.affectations.length > 1">...</span>
        </a>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showRecherche || showSelection">
        <recherche v-if="showRecherche"
               @toggleCriteresRecherche="showRecherche = !showRecherche"
               @appliquerCriteresRecherche="recherche()"/>
        <selection
          @ajoutProduitsSelectionnes="ajoutFacesAuReseau"
          @toggleSelection="showSelection = !showSelection"
          v-if="showSelection"/>
      </div>
    </transition>
    <b-modal v-model="showPopupAffectation"
             has-modal-card
             class="modal">
      <pop-up-affectations :produit="produitPourAffectation"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { REMOVE_PRODUIT, SET_PRODUIT } from '@/store/modules/produit-mutation-type';
import { CLEAR_BRIEF, CLEAR_PANIER, SET_PANIER } from '@/store/modules/produitFace-mutation-type';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE_PLANNING,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';
import TableItemsInView from '@/components/general/TableItemsInView';
import { DATE_MAX } from '@/configuration/general/dateConf';
import PopUpAffectations from '@/components/devisCommandes/rechercheCatalogue/popupAffectations';
import Recherche from '@/components/catalogue/produitReseau/ajoutFaces/recherche';
import Selection from '@/components/catalogue/selectionProduit/selectionAjoutProduits';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import { CATEGORIE_REGROUPEMENT_MAIRIE } from '@/configuration/catalogue/produitConf';
import { siteHasHolding } from '@/services/general/holding';

const ProduitStore = createNamespacedHelpers('produit');
const ProduitFace = createNamespacedHelpers('produitFace');
const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      showRecherche: false,
      showSelection: false,
      showPopupAffectation: false,
      produitPourAffectation: null,
      RESULTS_PER_PAGE_PLANNING: RESULTS_PER_PAGE_PLANNING,
      loadingComponent: false,
      unsubscribeValue: null,
    };
  },
  components: {
    AppBreadcrumb,
    TableItemsInView,
    PopUpAffectations,
    Recherche,
    Selection,
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...ProduitStore.mapGetters({
      produit: 'produit',
    }),
    ...ProduitFace.mapGetters({
      produits: 'produits',
      totalProduits: 'totalProduits',
      criteresRecherche: 'brief',
      selection: 'panier',
    }),
    breadcrumb() {
      const current = {
        title: this.$i18n.t('ecranAjoutFaces.title'),
        route: { name: 'l.bodac.catalogue-ajoutFacesAuReseau' },
        isActive: true,
      };
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'breadcrumb')) {
        const output = Array.from(this.$route.params.breadcrumb);
        output[output.length - 1].isActive = false;
        output.push(current);
        return output;
      }
      return [current];
    },
    nombreFiltre() {
      let nbFiltre = 0;
      Object.keys(this.criteresRecherche).forEach((nomParamBrief) => {
        if (nomParamBrief === 'toDate') return;
        if ((Array.isArray(this.criteresRecherche[nomParamBrief])
          && this.criteresRecherche[nomParamBrief].length > 0)
          || (!Array.isArray(this.criteresRecherche[nomParamBrief])
            && this.criteresRecherche[nomParamBrief] != null)) {
          nbFiltre += 1;
        }
      });
      return nbFiltre <= 9 ? nbFiltre : '9+';
    },
    columns() {
      return [
        'addPanier',
        'reference',
        'produitFace.format',
        'produitFace.materielType',
        'produitFace.adresse.adresse1',
        'produitFace.adresse.codePostal',
        'produitFace.adresse.ville',
        'affectation',
      ];
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          addPanier: '',
          reference: this.$i18n.t('ecranAjoutFaces.table.reference'),
          'produitFace.format': this.$i18n.t('ecranAjoutFaces.table.format'),
          'produitFace.materielType': this.$i18n.t('ecranAjoutFaces.table.materiel'),
          'produitFace.adresse.adresse1': this.$i18n.t('ecranAjoutFaces.table.address'),
          'produitFace.adresse.codePostal': this.$i18n.t('ecranAjoutFaces.table.zipCode'),
          'produitFace.adresse.ville': this.$i18n.t('ecranAjoutFaces.table.city'),
          affectation: this.$i18n.t('ecranAjoutFaces.table.affectation'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE_PLANNING,
        texts: TEXTS,
        sortable: [
          'reference',
          'produitFace.format',
          'produitFace.materielType',
          'produitFace.adresse.adresse1',
          'produitFace.adresse.codePostal',
          'produitFace.adresse.ville',
        ],
        columnsClasses: {
          addPanier: 'colonneSelected-35 is-paddingless',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (!data.query.toDate) data.query.toDate = DATE_MAX;
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          if (siteHasHolding()) {
            data.query.societeId = this.produit.supportCommercial.societeId;
          }
          if (this.produit.supportCommercial.categorieVente
            !== CATEGORIE_REGROUPEMENT_MAIRIE) data.query.proposableReseau = true;
          data.query.nonCommercialisable = (this.produit.supportCommercial.categorieVente
            === CATEGORIE_REGROUPEMENT_MAIRIE);
          data.sansDispo = true;
          return this.actionsLoadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
  },
  methods: {
    ...ProduitStore.mapMutations({
      removeProduit: REMOVE_PRODUIT,
      setProduit: SET_PRODUIT,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...ProduitFace.mapMutations({
      clearSelection: CLEAR_PANIER,
      clearCriteresRecherche: CLEAR_BRIEF,
      setSelection: SET_PANIER,
    }),
    ...ProduitFace.mapActions({
      actionsLoadProduits: 'loadProduits',
      actionsProduitInPanier: 'addProduitInPanier',
    }),
    recherche() {
      this.$refs.tableListeProduits.refresh();
    },
    goFirstPage() {
      this.$refs.tableListeProduits.setPage(1);
    },
    ajouterALaSelection(produit) {
      this.actionsProduitInPanier({
        produit: produit,
        dateDebut: this.criteresRecherche.fromDate,
        dateFin: this.criteresRecherche.toDate,
      });
    },
    getColorAddPanier(idProduit) {
      if (!this.selection) return 'is-primary';
      const isAlreadyAdd = this.selection.some((produit) => {
        return idProduit === produit.produit.id;
      });
      return isAlreadyAdd ? 'is-success' : 'is-primary';
    },
    formatDate(date) {
      return formatDate(date);
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    async ajoutFacesAuReseau() {
      this.produit.produitReseau.affectationsReseauFace = this.selection;
      this.setProduit(this.produit);
      await this.$router.go(-1);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    annuler() {
      this.clearSelection();
      this.clearCriteresRecherche();
      this.$router.go(-1);
    },
    affichageAffectations(produit) {
      this.produitPourAffectation = produit;
      this.showPopupAffectation = true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!['m.bodac.catalogue-nouveauReseau', 'm.bodac.catalogue-nouveauReseauMairie', 'm.bodac.catalogue-nouveauReseauLc', 'm.bodac.catalogue-editionReseauLc', 'm.bodac.catalogue-editionReseau', 'm.bodac.catalogue-editionReseauMairie'].includes(to.name)) {
      this.removeProduit();
      this.clearSelection();
      this.clearCriteresRecherche();
    }
    next();
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete) {
      this.unsubscribeValue();
    }
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key]);
      if (this.filtrerProduitParSociete) {
        this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      }
      this.setInformationPage(this.$t('pageGescom.planning.face'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  beforeMount() {
    if (!this.$route.params.breadcrumb || !this.produit) {
      this.removeProduit();
      if (this.loadingComponent) this.loadingComponent.close();
      this.$router.go(-1);
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    const facesAssocies = cloneDeep(this.produit.produitReseau.affectationsReseauFace);
    facesAssocies.forEach((face) => {
      face.isAlreadySelect = true;
    });
    this.setSelection(facesAssocies);
    loadingComponent.close();
  },
};

</script>
